import { isTokenExpired } from '../utils/WalletUtils';

export default {
  filters: {
    /**
     * Filter to format expiration date based on isTokenExpired
     */
    expiration(value) {
      const expString = `${value.substring(0, 2)}/${value.substring(2, 4)}`;
      return isTokenExpired(value) ? `Expired ${expString}` : `Expiring ${expString}`;
    },
  },
};
